import React from 'react';
import { Redirect, Router, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import history from '../../history';
import routes from '../../utils/routes';
import CredentialsHelper from '../../utils/credentials-helper';
import { convertCode } from './app.actions';
import InternalPagesContainer from '../internal-pages/internal-pages';
import Alert from '../alerts/alert';
import Loader from '../commons/loader/loader';
import LoginRedirect from '../login/login-redirect';

import './app.css';

export class App extends React.Component {

    render() {
        return (
            <React.Fragment>
                <Alert alerts={this.props.App.alerts} />
                <Router history={history}>
                    <Switch>
                        <Root exact path={routes.ROOT}/>
                        <InternalPagesContainer {...this.props} history={history}/>
                    </Switch>
                </Router>
            </React.Fragment>
        );
    }
}

class _Root extends React.Component {
    componentDidMount() {
        const code = new URLSearchParams(this.props.location.search).get('code');
        if (code) {
            this.props.convertCode(code);
        }
    }

    render() {
        if (CredentialsHelper.isLoggedIn) {
            return <Redirect to={routes.HOME}/>;
        }
        if (new URLSearchParams(this.props.location.search).get('code')) {
            return <Loader/>;
        }
        return <LoginRedirect/>;
    }
}

const Root = connect(null, dispatch => bindActionCreators({ convertCode }, dispatch))(_Root);

const mapStateToProps = state => ({
    App: state.App,
    questionsDatabase: state.questionsDatabase,
});

export default connect(mapStateToProps, {})(App);



// WEBPACK FOOTER //
// ./src/components/app/app.js